module.exports = __webpack_public_path__ + "img/7.4a556f07.jpg";